module.exports = __webpack_public_path__ + "img/it-consulting-color.8b9f2ea0.png";